module.exports = __webpack_public_path__ + "img/ic_prev_default.b5c0d9d9.svg";